import { useRecoilValue } from 'recoil'
import alarmSituationsAtom from '@/pages/Processes/AlarmSituations/alarmSituations.atom.ts'
import { ISystemEvent } from '@/pages/SystemEvents/systemEvents.types'

interface IProps {
  notification: ISystemEvent
}

const SystemEventTableDescription = (props: IProps) => {
  const alarmSituations = useRecoilValue(alarmSituationsAtom).items

  switch (props.notification.type) {
    case 'SYSTEM_LOG':
      return props.notification.description
    case 'LP_ERROR':
      return (
        <p className="text-nm" style={{ whiteSpace: 'pre-wrap' }}>
          Код ошибки:{props.notification.payload.errorCode}:{'\n'}
          {props.notification.payload.errorDescription}
        </p>
      )
    case 'ALARM_SITUATION_INCIDENT':
      // @ts-ignore
      const alarmSituation = alarmSituations.find((s) => s.id === props.notification.payload.alarmSituationId)

      if (!alarmSituation) {
        return props.notification.description
      }
      return alarmSituation.name
    default:
      return props.notification.description
  }
}

export default SystemEventTableDescription
